<template>
  <div class="flex flex-col items-center gap-2">
    <div class="relative">
      <svg width="100" viewBox="0 0 200 120">
        <path
          v-for="(arc, i) in arcs"
          :key="i"
          :d="describeArc(100, 100, 80, arc.startAngle, arc.endAngle)"
          :style="{ stroke: arc.color }"
          :stroke-width="highlightColor == arc.color ? 20 : 13"
          fill="none"
          :opacity="highlightColor == arc.color ? 1 : 0.4"
          stroke-linecap="round"
        />

        <g transform="rotate(-90, 100, 100)">
          <!-- <circle
            v-if="showDot"
            :cx="percentagePosition.x"
            :cy="percentagePosition.y"
            r="13"
            fill="white"
            :stroke="highlightColor"
            stroke-width="5"
          /> -->
        </g>
      </svg>
    </div>
    <div class="absolute mt-10">
      <slot>{{ modelValue }}</slot>
    </div>
    <div class="text-secondary text-center">{{ props.label }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Number,
    default: null
  },
  breakPoints: {
    type: Array,
    default: () => [50, 80]
  },
  reverseBreakPoints: {
    type: Boolean,
    default: false
  },
  reverseDial: {
    type: Boolean,
    default: false
  },
  label: {
    type: Number,
    default: 0
  }
})

const highlightColor = computed(() => {
  if (!props.breakPoints) return
  if (props.reverseBreakPoints) {
    if (props.modelValue < props.breakPoints[0]) {      
      return '#4ca30d'
    } else if (props.modelValue < props.breakPoints[1]) {
      return '#e89110'
    } else {
      return '#d21c3c'
    }
  } else {
    if (props.modelValue < props.breakPoints[0]) {
      return '#d21c3c'
    } else if (props.modelValue < props.breakPoints[1]) {
      return '#e89110'
    } else {
      return '#4ca30d'
    }
  }


})

const numSections = 3
const totalArc = 180
const gapDegrees = 14 // amount of angular gap between arcs (in total, 2 degrees per side)
const arcSweep = (totalArc - gapDegrees * (numSections - 1)) / numSections

const startBase = 90
const colors = ['#4ca30d', '#e89110', '#d21c3c']

const arcs = computed(() => {
  const arcsArray = []
  for (let i = 0; i < numSections; i++) {
    const startAngle = startBase - i * (arcSweep + gapDegrees)
    const endAngle = startAngle - arcSweep
    // Reverse color order when reverseDial is true
    const colorIndex = props.reverseDial ? colors.length - 1 - i : i
    arcsArray.push({
      color: colors[colorIndex],
      startAngle,
      endAngle
    })
  }
  return arcsArray
})

function polarToCartesian(cx, cy, r, angleInDegrees) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0
  return {
    x: cx + r * Math.cos(angleInRadians),
    y: cy + r * Math.sin(angleInRadians)
  }
}

function describeArc(cx, cy, r, startAngle, endAngle) {
  const start = polarToCartesian(cx, cy, r, startAngle)
  const end = polarToCartesian(cx, cy, r, endAngle)
  const largeArcFlag = Math.abs(endAngle - startAngle) > 180 ? '1' : '0'

  return ['M', start.x, start.y, 'A', r, r, 0, largeArcFlag, 0, end.x, end.y].join(' ')
}

// Optional: map a percentage (0–100) to a point on the arc
const percentage = 100 - props.percentage // change this modelV (0 to 100)
const showDot = true

// for dot position
// const percentagePosition = computed(() => {
//   const angle = 180 - (percentage / 100) * 180
//   return polarToCartesian(100, 100, 80, angle)
// })
</script>
